// Non-autogenerated types and constants for calcs

import { CALC_FUNCTION_DICTIONARY } from "./CalcFunctionDictionary.js";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- calling map is fine
export const CALC_FUNCTIONS_LIST = Object.values(CALC_FUNCTION_DICTIONARY).map(
  (f) => f[0]!.name,
);

//prettier-ignore
export const CALC_SYMBOLIC_OPERATORS_LIST = [
    "<=", ">=", "=", "!=", "<>", // comparison
    "+", "-", "*", "/", "**", "^", "%", // math
    "&&", "||", "!", // logic
    "&", // string concat
] as const;

//prettier-ignore
export const CALC_KEYWORD_OPERATOR_LIST = [
  "as", "and", "or", "not",
] as const;

//prettier-ignore
export const CALC_KEYWORD_VALUE_LIST = [
  "true", "false", "null",
] as const;

export const CALC_ALL_OPERATORS_LIST = [
  ...CALC_SYMBOLIC_OPERATORS_LIST,
  ...CALC_KEYWORD_OPERATOR_LIST,
] as const;

export const CALC_ALL_KEYWORDS_LIST = [
  ...CALC_KEYWORD_OPERATOR_LIST,
  ...CALC_KEYWORD_VALUE_LIST,
] as const;

const IDENTIFIER_REGEX = /^[a-zA-Z][a-zA-Z_0-9]*$/;
export const columnNameNeedsBackticks = (columnName: string): boolean =>
  !IDENTIFIER_REGEX.test(columnName);
